export default {
  "\\": "é",
  "{": "ç",
  "§00": "{FILLER}",
  "0137": "{FILLER}",
  "1120": "{COLOR:WHITE}",
  "112e": "{ITALICS}",
  "112f": "{ITALICS_UNDERLINE}",
  "1130": "®",
  "1131": "°",
  "1132": "½",
  "1133": "¿",
  "1134": "™",
  "1135": "¢",
  "1136": "£",
  "1137": "♪",
  "1138": "à",
  // "1139": " ", // transparent space
  "113a": "è",
  "113b": "â",
  "113c": "ê",
  "113d": "î",
  "113e": "ô",
  "113f": "û",
  "1220": "Á",
  "1221": "É",
  "1222": "Ó",
  "1223": "Ú",
  "1224": "Ü",
  "1225": "ü",
  "1226": "‘",
  "1227": "¡",
  "1228": "*",
  "1229": "’",
  "122a": "—",
  "122b": "©",
  "122c": "℠",
  "122d": "•",
  "122e": '“',
  "122f": '”',
  "1230": "À",
  "1231": "Â",
  "1232": "Ç",
  "1233": "È",
  "1234": "Ê",
  "1235": "Ë",
  "1236": "ë",
  "1237": "Î",
  "1238": "Ï",
  "1239": "ï",
  "123a": "Ô",
  "123b": "Ù",
  "123c": "ù",
  "123d": "Û",
  "123e": "«",
  "123f": "»",
  "1320": "Ã",
  "1321": "ã",
  "1322": "Í",
  "1323": "Ì",
  "1324": "ì",
  "1325": "Ò",
  "1326": "ò",
  "1327": "Õ",
  "1328": "õ",
  "1329": "{",
  "132a": "}",
  "132b": "\\",
  "132c": "^",
  "132d": "_",
  "132e": "¦",
  "132f": "~",
  "1330": "Ä",
  "1331": "ä",
  "1332": "Ö",
  "1333": "ö",
  "1334": "ß",
  "1335": "¥",
  "1336": "¤",
  "1337": "|",
  "1338": "Å",
  "1339": "å",
  "133a": "Ø",
  "133b": "ø",
  "133c": "┌",
  "133d": "┐",
  "133e": "└",
  "133f": "┘",
  "142e": "{CLEAR BUFFER}",
  "142f": "{DISPLAY BUFFER}",
  "142c": "{CLEAR DISPLAY}",
  "1420": "{RESUME LOADING}",
  "1425": "{ROLLUP2}",
  "1426": "{ROLLUP3}",
  "1427": "{ROLLUP4}",
  "1429": "{PAINT ON}",
  "1721": "{TAB01}",
  // Tab Over
  "1722": "{TAB02}",
  // Tab Over 2
  "1723": "{TAB03}",
  // Tab Over 3
  "114e": "{00_00}{ITALICS}",
  "114f": "{00_00}{ITALICS_UNDERLINE}",
  "1150": "{00_00}",
  "1151": "{00_00}{UNDERLINE}",
  "1152": "{00_04}",
  "1153": "{00_04}{UNDERLINE}",
  "1154": "{00_08}",
  "1155": "{00_08}{UNDERLINE}",
  "1156": "{00_12}",
  "1157": "{00_12}{UNDERLINE}",
  "1158": "{00_16}",
  "1159": "{00_16}{UNDERLINE}",
  "115a": "{00_20}",
  "115b": "{00_20}{UNDERLINE}",
  "115c": "{00_24}",
  "115d": "{00_24}{UNDERLINE}",
  "115e": "{00_28}",
  "115f": "{00_28}{UNDERLINE}",
  "1170": "{01_00}",
  "1171": "{01_00}{UNDERLINE}",
  "1172": "{01_04}",
  "1173": "{01_04}{UNDERLINE}",
  "1174": "{01_08}",
  "1175": "{01_08}{UNDERLINE}",
  "1176": "{01_12}",
  "1177": "{01_12}{UNDERLINE}",
  "1178": "{01_16}",
  "1179": "{01_16}{UNDERLINE}",
  "117a": "{01_20}",
  "117b": "{01_20}{UNDERLINE}",
  "117c": "{01_24}",
  "117d": "{01_24}{UNDERLINE}",
  "117e": "{01_28}",
  "117f": "{01_28}{UNDERLINE}",
  "1250": "{02_00}",
  "1251": "{02_00}{UNDERLINE}",
  "1252": "{02_04}",
  "1253": "{02_04}{UNDERLINE}",
  "1254": "{02_08}",
  "1255": "{02_08}{UNDERLINE}",
  "1256": "{02_12}",
  "1257": "{02_12}{UNDERLINE}",
  "1258": "{02_16}",
  "1259": "{02_16}{UNDERLINE}",
  "125a": "{02_20}",
  "125b": "{02_20}{UNDERLINE}",
  "125c": "{02_24}",
  "125d": "{02_24}{UNDERLINE}",
  "125e": "{02_28}",
  "125f": "{02_28}{UNDERLINE}",
  "1270": "{03_00}",
  "1271": "{03_00}{UNDERLINE}",
  "1272": "{03_04}",
  "1273": "{03_04}{UNDERLINE}",
  "1274": "{03_08}",
  "1275": "{03_08}{UNDERLINE}",
  "1276": "{03_12}",
  "1277": "{03_12}{UNDERLINE}",
  "1278": "{03_16}",
  "1279": "{03_16}{UNDERLINE}",
  "127a": "{03_20}",
  "127b": "{03_20}{UNDERLINE}",
  "127c": "{03_24}",
  "127d": "{03_24}{UNDERLINE}",
  "127e": "{03_28}",
  "127f": "{03_28}{UNDERLINE}",
  "1550": "{04_00}",
  "1551": "{04_00}{UNDERLINE}",
  "1552": "{04_04}",
  "1553": "{04_04}{UNDERLINE}",
  "1554": "{04_08}",
  "1555": "{04_08}{UNDERLINE}",
  "1556": "{04_12}",
  "1557": "{04_12}{UNDERLINE}",
  "1558": "{04_16}",
  "1559": "{04_16}{UNDERLINE}",
  "155a": "{04_20}",
  "155b": "{04_20}{UNDERLINE}",
  "155c": "{04_24}",
  "155d": "{04_24}{UNDERLINE}",
  "155e": "{04_28}",
  "155f": "{04_28}{UNDERLINE}",
  "1570": "{05_00}",
  "1571": "{05_00}{UNDERLINE}",
  "1572": "{05_04}",
  "1573": "{05_04}{UNDERLINE}",
  "1574": "{05_08}",
  "1575": "{05_08}{UNDERLINE}",
  "1576": "{05_12}",
  "1577": "{05_12}{UNDERLINE}",
  "1578": "{05_16}",
  "1579": "{05_16}{UNDERLINE}",
  "157a": "{05_20}",
  "157b": "{05_20}{UNDERLINE}",
  "157c": "{05_24}",
  "157d": "{05_24}{UNDERLINE}",
  "157e": "{05_28}",
  "157f": "{05_28}{UNDERLINE}",
  "1650": "{06_00}",
  "1651": "{06_00}{UNDERLINE}",
  "1652": "{06_04}",
  "1653": "{06_04}{UNDERLINE}",
  "1654": "{06_08}",
  "1655": "{06_08}{UNDERLINE}",
  "1656": "{06_12}",
  "1657": "{06_12}{UNDERLINE}",
  "1658": "{06_16}",
  "1659": "{06_16}{UNDERLINE}",
  "165a": "{06_20}",
  "165b": "{06_20}{UNDERLINE}",
  "165c": "{06_24}",
  "165d": "{06_24}{UNDERLINE}",
  "165e": "{06_28}",
  "165f": "{06_28}{UNDERLINE}",
  "1670": "{07_00}",
  "1671": "{07_00}{UNDERLINE}",
  "1672": "{07_04}",
  "1673": "{07_04}{UNDERLINE}",
  "1674": "{07_08}",
  "1675": "{07_08}{UNDERLINE}",
  "1676": "{07_12}",
  "1677": "{07_12}{UNDERLINE}",
  "1678": "{07_16}",
  "1679": "{07_16}{UNDERLINE}",
  "167a": "{07_20}",
  "167b": "{07_20}{UNDERLINE}",
  "167c": "{07_24}",
  "167d": "{07_24}{UNDERLINE}",
  "167e": "{07_28}",
  "167f": "{07_28}{UNDERLINE}",
  "1750": "{08_00}",
  "1751": "{08_00}{UNDERLINE}",
  "1752": "{08_04}",
  "1753": "{08_04}{UNDERLINE}",
  "1754": "{08_08}",
  "1755": "{08_08}{UNDERLINE}",
  "1756": "{08_12}",
  "1757": "{08_12}{UNDERLINE}",
  "1758": "{08_16}",
  "1759": "{08_16}{UNDERLINE}",
  "175a": "{08_20}",
  "175b": "{08_20}{UNDERLINE}",
  "175c": "{08_24}",
  "175d": "{08_24}{UNDERLINE}",
  "175e": "{08_28}",
  "175f": "{08_28}{UNDERLINE}",
  "1770": "{09_00}",
  "1771": "{09_00}{UNDERLINE}",
  "1772": "{09_04}",
  "1773": "{09_04}{UNDERLINE}",
  "1774": "{09_08}",
  "1775": "{09_08}{UNDERLINE}",
  "1776": "{09_12}",
  "1777": "{09_12}{UNDERLINE}",
  "1778": "{09_16}",
  "1779": "{09_16}{UNDERLINE}",
  "177a": "{09_20}",
  "177b": "{09_20}{UNDERLINE}",
  "177c": "{09_24}",
  "177d": "{09_24}{UNDERLINE}",
  "177e": "{09_28}",
  "177f": "{09_28}{UNDERLINE}",
  "1050": "{10_00}",
  "1051": "{10_00}{UNDERLINE}",
  "1052": "{10_04}",
  "1053": "{10_04}{UNDERLINE}",
  "1054": "{10_08}",
  "1055": "{10_08}{UNDERLINE}",
  "1056": "{10_12}",
  "1057": "{10_12}{UNDERLINE}",
  "1058": "{10_16}",
  "1059": "{10_16}{UNDERLINE}",
  "105a": "{10_20}",
  "105b": "{10_20}{UNDERLINE}",
  "105c": "{10_24}",
  "105d": "{10_24}{UNDERLINE}",
  "105e": "{10_28}",
  "105f": "{10_28}{UNDERLINE}",
  "1350": "{11_00}",
  "1351": "{11_00}{UNDERLINE}",
  "1352": "{11_04}",
  "1353": "{11_04}{UNDERLINE}",
  "1354": "{11_08}",
  "1355": "{11_08}{UNDERLINE}",
  "1356": "{11_12}",
  "1357": "{11_12}{UNDERLINE}",
  "1358": "{11_16}",
  "1359": "{11_16}{UNDERLINE}",
  "135a": "{11_20}",
  "135b": "{11_20}{UNDERLINE}",
  "135c": "{11_24}",
  "135d": "{11_24}{UNDERLINE}",
  "135e": "{11_28}",
  "135f": "{11_28}{UNDERLINE}",
  "1370": "{12_00}",
  "1371": "{12_00}{UNDERLINE}",
  "1372": "{12_04}",
  "1373": "{12_04}{UNDERLINE}",
  "1374": "{12_08}",
  "1375": "{12_08}{UNDERLINE}",
  "1376": "{12_12}",
  "1377": "{12_12}{UNDERLINE}",
  "1378": "{12_16}",
  "1379": "{12_16}{UNDERLINE}",
  "137a": "{12_20}",
  "137b": "{12_20}{UNDERLINE}",
  "137c": "{12_24}",
  "137d": "{12_24}{UNDERLINE}",
  "137e": "{12_28}",
  "137f": "{12_28}{UNDERLINE}",
  "144a": "{13_00}",
  "144e": "{13_00}{ITALICS}",
  "144f": "{13_00}{ITALICS_UNDERLINE}",
  "1450": "{13_00}",
  "1451": "{13_00}{UNDERLINE}",
  "1452": "{13_04}",
  "1453": "{13_04}{UNDERLINE}",
  "1454": "{13_08}",
  "1455": "{13_08}{UNDERLINE}",
  "1456": "{13_12}",
  "1457": "{13_12}{UNDERLINE}",
  "1458": "{13_16}",
  "1459": "{13_16}{UNDERLINE}",
  "145a": "{13_20}",
  "145b": "{13_20}{UNDERLINE}",
  "145c": "{13_24}",
  "145d": "{13_24}{UNDERLINE}",
  "145e": "{13_28}",
  "145f": "{13_28}{UNDERLINE}",
  "146e": "{14_00}{ITALICS}",
  "146f": "{14_00}{ITALICS_UNDERLINE}",
  "1470": "{14_00}",
  "1471": "{14_00}{UNDERLINE}",
  "1472": "{14_04}",
  "1473": "{14_04}{UNDERLINE}",
  "1474": "{14_08}",
  "1475": "{14_08}{UNDERLINE}",
  "1476": "{14_12}",
  "1477": "{14_12}{UNDERLINE}",
  "1478": "{14_16}",
  "1479": "{14_16}{UNDERLINE}",
  "147a": "{14_20}",
  "147b": "{14_20}{UNDERLINE}",
  "147c": "{14_24}",
  "147d": "{14_24}{UNDERLINE}",
  "147e": "{14_28}",
  "147f": "{14_28}{UNDERLINE}",
  "112a": " ",
  "142d": "{NEW LINE}",
  "1428": "{FILLER}",
  "11a1": "{COLOR:WHITE;UNDERLINE}",
  "11a2": "{COLOR:GREEN}",
  "1123": "{COLOR:GREEN;UNDERLINE}",
  "11a4": "{COLOR:BLUE}",
  "1125": "{COLOR:BLUE;UNDERLINE}",
  "1126": "{COLOR:CYAN}",
  "11a7": "{COLOR:CYAN;UNDERLINE}",
  "11a8": "{COLOR:RED}",
  "1129": "{COLOR:RED;UNDERLINE}",
  "112a": "{COLOR:YELLOW}",
  "11ab": "{COLOR:YELLOW;UNDERLINE}",
  "112c": "{COLOR:MAGENTA}",
  "11ad": "{COLOR:MAGENTA;UNDERLINE}",
  "17ae": "{COLOR:BLACK}",
  "172f": "{COLOR:BLACK;UNDERLINE}"
};